import {CAPABILITIES, type Capability} from '@dokia/domain-model';

import {decodeJwtPayload} from './decodeJwtPayload';

export const getAccessTokenCapabilities = (
  accessToken: string | undefined,
): Capability[] => {
  if (!accessToken) {
    return [];
  }

  const jwtPayload = decodeJwtPayload<{permissions?: string[]}>(accessToken);

  if (!jwtPayload?.permissions) {
    return [];
  }

  return jwtPayload.permissions.filter(permission => isCapability(permission));
};

export const isCapability = (permission: string): permission is Capability => {
  return Object.prototype.hasOwnProperty.call(CAPABILITIES, permission);
};
